import { Check, Trophy } from "lucide-react";

export function SignupPlanPicker({ plans, selected, onSelect, gstPct }) {
  return (
    <fieldset className="rounded-2xl border border-amber-500/20 bg-amber-500/[0.03] p-4" data-testid="register-plan-section">
      <legend className="px-2 text-xs uppercase tracking-[0.15em] text-amber-300">Choose Your Plan</legend>
      <div className="grid grid-cols-2 gap-2.5">
        {plans.map((p) => {
          const on = selected === p.id;
          return (
            <button type="button" key={p.id} onClick={() => onSelect(p.id)} data-testid={`register-plan-${p.id}`}
              className={`relative text-left rounded-xl border px-3 py-2.5 transition-colors ${on ? "border-amber-400 bg-amber-500/10" : "border-amber-500/15 hover:border-amber-400/50"}`}>
              {on && <Check size={14} className="absolute top-2 right-2 text-amber-300" />}
              <p className="text-sm text-slate-100 font-medium">{p.name}</p>
              <p className="font-serif text-lg text-amber-100">₹{p.price}</p>
              <p className="text-[10px] text-slate-400">{p.validity_months === 1 ? "1 month" : `${p.validity_months} months`} · Qs ₹{p.per_question_price}</p>
              {p.validity_months >= 3 && <p className="mt-1 text-[10px] text-amber-300 flex items-center gap-1"><Trophy size={10} /> Double draw chance</p>}
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-[11px] text-slate-500">+ {gstPct}% GST. Your account is created after successful payment.</p>
    </fieldset>
  );
}
